import { createFileRoute, redirect } from '@tanstack/react-router'

import { readAdminSession, readClubSession } from '@/lib/auth/session-store'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const club = readClubSession()
    if (club) throw redirect({ to: '/dashboard' })
    const admin = readAdminSession()
    if (admin) throw redirect({ to: '/admin/clubs' })
    throw redirect({ to: '/login' })
  },
})
